var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationSessionexpire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4954 22.7653C19.6743 21.696 20.0412 20.9069 21.1437 20.6672C22.8067 20.3058 24.4531 19.6531 26.1235 19.5978C28.5738 19.5167 29.9031 21.3327 29.4108 23.724C29.1877 24.8044 28.8596 25.8775 28.4576 26.9062C27.5469 29.2422 26.5365 31.5394 25.6184 33.8717C25.3658 34.5115 25.2478 35.2139 25.1464 35.8998C25.0228 36.7405 25.4303 37.301 26.2913 37.2991C27.2205 37.2973 28.1497 37.1461 29.1048 37.0576C28.9167 37.961 28.5738 38.6856 27.4842 39.0414C25.8543 39.5761 24.2946 40.262 22.5099 40.1458C19.9785 39.9799 18.4851 38.2782 19.1636 35.85C19.8255 33.479 20.8469 31.2076 21.7079 28.8901C22.237 27.4649 22.8528 26.0618 23.2621 24.6016C23.7673 22.7985 23.1662 22.1735 21.2838 22.3707C20.7012 22.4316 20.1315 22.6233 19.4991 22.7671L19.4954 22.7653Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1848 9.00035C30.3161 9.02616 32.0363 10.6855 31.9994 12.6785C31.9625 14.6679 30.1797 16.2848 28.0631 16.2516C25.9078 16.2184 24.1987 14.6052 24.2024 12.6048C24.2042 10.5878 25.9889 8.97269 28.1866 9.00035H28.1848Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationSessionexpire);
export default __webpack_public_path__ + "static/media/information_sessionexpire.c1e68bea02061713ba433830734af51b.svg";
export { ForwardRef as ReactComponent };